import React from "react"

import { Content, GridContent } from "../App.styles"
import { Head } from "./Head"
import { Version } from "../Version"

type Props = {
  children: React.ReactNode
}

export function Layout({ children }: Props) {
  return (
    <Content>
      <GridContent>
        <Head />
        {children}
      </GridContent>
      <Version />
    </Content>
  )
}
